module.exports = __webpack_public_path__ + "img/checking-docs-mobile.f5f869fd.svg";